import { CurveType } from '../enums';

export const ACCELERATION_TORQUE_WITH_YD_COLOR = '#CC9200';

export const CURVE_COLORS = new Map<CurveType, string>([
    [CurveType.TorqueOverSpeed, '#00A7E0'],
    [CurveType.TorqueOverSpeedWithSpecificVoltage, '#00A7E0'],
    [CurveType.Load, '#BC672C'],
    [CurveType.LimitCurve, '#B537F2'],
    [CurveType.AccelerationTorque, '#FFB700'],
    [CurveType.AccelerationTorqueWithSpecificVoltage, '#FFB700'],
    [CurveType.CurrentOverSpeed, '#F7323F'],
    [CurveType.CurrentOverSpeedWithSpecificVoltage, '#F7323F'],
    [CurveType.DolStarDeltaTorque, '#0074C7'],
    [CurveType.DolStarDeltaCurrent, '#B90713'],
    [CurveType.LoadPower, '#FF5319'],
    [CurveType.MotorShaftPower, '#FF8C00'],
    [CurveType.MotorShaftPowerWithSpecificVoltage, '#FF8C00'],
    [CurveType.StartUpTime, '#00FFC0'],
    [CurveType.StartUpTimeWithSpecificVoltage, '#00FFC0'],
    [CurveType.StartUpTimeWithYD, '#00FF40'],
    [CurveType.CurrentOverTimeWithY, '#F7323F'],
    [CurveType.CurrentOverTimeWithYWithSpecificVoltage, '#F7323F'],
    [CurveType.CurrentOverTimeWithD, '#F7323F'],
    [CurveType.CurrentOverTimeWithDWithSpecificVoltage, '#F7323F'],
    [CurveType.CurrentOverTimeWithYD, '#F732A1'],
    [CurveType.VsdTorqueLimit, '#00A7E0'],
    [CurveType.VsdPowerLimit, '#FF8C00']
]);
